var _observers, _mutationCache, _retryer, _Class_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// src/mutation.ts
import { notifyManager } from "./notifyManager.js";
import { Removable } from "./removable.js";
import { createRetryer } from "./retryer.js";
var Mutation = (_observers = /*#__PURE__*/new WeakMap(), _mutationCache = /*#__PURE__*/new WeakMap(), _retryer = /*#__PURE__*/new WeakMap(), _Class_brand = /*#__PURE__*/new WeakSet(), class Mutation extends Removable {
  constructor(config) {
    super();
    _classPrivateMethodInitSpec(this, _Class_brand);
    _classPrivateFieldInitSpec(this, _observers, void 0);
    _classPrivateFieldInitSpec(this, _mutationCache, void 0);
    _classPrivateFieldInitSpec(this, _retryer, void 0);
    this.mutationId = config.mutationId;
    _classPrivateFieldSet(_mutationCache, this, config.mutationCache);
    _classPrivateFieldSet(_observers, this, []);
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = options;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!_classPrivateFieldGet(_observers, this).includes(observer)) {
      _classPrivateFieldGet(_observers, this).push(observer);
      this.clearGcTimeout();
      _classPrivateFieldGet(_mutationCache, this).notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    _classPrivateFieldSet(_observers, this, _classPrivateFieldGet(_observers, this).filter(x => x !== observer));
    this.scheduleGc();
    _classPrivateFieldGet(_mutationCache, this).notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!_classPrivateFieldGet(_observers, this).length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        _classPrivateFieldGet(_mutationCache, this).remove(this);
      }
    }
  }
  continue() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3;
    return (_classPrivateFieldGet2 = (_classPrivateFieldGet3 = _classPrivateFieldGet(_retryer, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.continue()) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 :
    // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(variables) {
    var _this$options$retry;
    const onContinue = () => {
      _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
        type: "continue"
      });
    };
    _classPrivateFieldSet(_retryer, this, createRetryer({
      fn: () => {
        if (!this.options.mutationFn) {
          return Promise.reject(new Error("No mutationFn found"));
        }
        return this.options.mutationFn(variables);
      },
      onFail: (failureCount, error) => {
        _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
          type: "failed",
          failureCount,
          error
        });
      },
      onPause: () => {
        _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
          type: "pause"
        });
      },
      onContinue,
      retry: (_this$options$retry = this.options.retry) !== null && _this$options$retry !== void 0 ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => _classPrivateFieldGet(_mutationCache, this).canRun(this)
    }));
    const restored = this.state.status === "pending";
    const isPaused = !_classPrivateFieldGet(_retryer, this).canStart();
    try {
      var _classPrivateFieldGet6, _classPrivateFieldGet7, _this$options$onSucce, _this$options2, _classPrivateFieldGet8, _classPrivateFieldGet9, _this$options$onSettl, _this$options3;
      if (restored) {
        onContinue();
      } else {
        var _classPrivateFieldGet4, _classPrivateFieldGet5, _this$options$onMutat, _this$options;
        _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
          type: "pending",
          variables,
          isPaused
        });
        await ((_classPrivateFieldGet4 = (_classPrivateFieldGet5 = _classPrivateFieldGet(_mutationCache, this).config).onMutate) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.call(_classPrivateFieldGet5, variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables));
        if (context !== this.state.context) {
          _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
            type: "pending",
            context,
            variables,
            isPaused
          });
        }
      }
      const data = await _classPrivateFieldGet(_retryer, this).start();
      await ((_classPrivateFieldGet6 = (_classPrivateFieldGet7 = _classPrivateFieldGet(_mutationCache, this).config).onSuccess) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.call(_classPrivateFieldGet7, data, variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context));
      await ((_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, null, this.state.variables, this.state.context, this));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context));
      _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
        type: "success",
        data
      });
      return data;
    } catch (error) {
      try {
        var _classPrivateFieldGet10, _classPrivateFieldGet11, _this$options$onError, _this$options4, _classPrivateFieldGet12, _classPrivateFieldGet13, _this$options$onSettl2, _this$options5;
        await ((_classPrivateFieldGet10 = (_classPrivateFieldGet11 = _classPrivateFieldGet(_mutationCache, this).config).onError) === null || _classPrivateFieldGet10 === void 0 ? void 0 : _classPrivateFieldGet10.call(_classPrivateFieldGet11, error, variables, this.state.context, this));
        await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context));
        await ((_classPrivateFieldGet12 = (_classPrivateFieldGet13 = _classPrivateFieldGet(_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.call(_classPrivateFieldGet13, void 0, error, this.state.variables, this.state.context, this));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context));
        throw error;
      } finally {
        _assertClassBrand(_Class_brand, this, _dispatch).call(this, {
          type: "error",
          error
        });
      }
    } finally {
      _classPrivateFieldGet(_mutationCache, this).runNext(this);
    }
  }
});
function _dispatch(action) {
  const reducer = state => {
    switch (action.type) {
      case "failed":
        return {
          ...state,
          failureCount: action.failureCount,
          failureReason: action.error
        };
      case "pause":
        return {
          ...state,
          isPaused: true
        };
      case "continue":
        return {
          ...state,
          isPaused: false
        };
      case "pending":
        return {
          ...state,
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...state,
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        };
      case "error":
        return {
          ...state,
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        };
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    _classPrivateFieldGet(_observers, this).forEach(observer => {
      observer.onMutationUpdate(action);
    });
    _classPrivateFieldGet(_mutationCache, this).notify({
      mutation: this,
      type: "updated",
      action
    });
  });
}
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
export { Mutation, getDefaultState };